<template>
    <div class="FDialog">
        <el-dialog :title="title" 
                   ref="el_dialog"
                   :before-close="close"
                   :custom-class="moveWidth?'move_Dialog':''"
                   :width="moveWidth?moveWidth:width"
                   :close-on-press-escape="false"
                   :close-on-click-modal="false"
                   :modal="modal"
                   :visible.sync="dialog"
                   :modal-append-to-body='false'>
            <slot v-if="dialogSlot"></slot>
            <div slot="footer" class="dialog-footer" v-if="dialogSlot">
                <slot name="bom"></slot>
            </div>
        </el-dialog>
    </div>
    <!-- v-move-dialog="{move:moveWidth}" 移动-->
</template>
<script>
    /**
     @author xiaoye
     @date 2020/4/8 3:45 下午
     */
    export default {
        name: 'FDialog',
        components: {},
        props: {
            title: {
                type: String,
                default: 'name'
            },
            dialog: {
                type: Boolean,
                default: false
            },
            moveWidth: {
                type: String,
                default: ''
            },
            width: {
                type: String,
                default: '40%'
            },
            modal: {
                type: Boolean,
                default: true
            },
        },
        data() {
            return {
                dialogSlot: false,
            }
        },
        methods: {
            getLeft() {
                if (this.moveWidth) {
                    this.$refs.el_dialog.$el.firstElementChild.style.left = 'calc(50% - ' + this.moveWidth + ' / 2)';
                }
            },
            close() {
                this.$emit("close");
            }
        },
        watch: {
            dialog(val) {
                if (val) {
                    this.dialogSlot = val;
                } else {
                    setTimeout(() => {
                        this.dialogSlot = val;
                    }, 500)
                }
            }
        },
        mounted() {
            this.getLeft();
        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .FDialog {

    }
</style>